import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { PasswordResetPageVariant } from 'api/password_reset_classes';

import { CandidatePortalEditor } from 'components/CandidatePortalEditor/CandidatePortalEditor';
import { EmployeePage } from 'components/EmployeePage/EmployeePage';
import { ErrorPage } from 'components/ErrorPage/ErrorPage';
import { ExpiredPage } from 'components/ExpiredPage/ExpiredPage';
import { ForbiddenPage } from 'components/ForbiddenPage/ForbiddenPage';
import { LoginPage } from 'components/LoginPage/LoginPage';
import { NotFoundPage } from 'components/NotFoundPage/NotFoundPage';
import { PasswordResetPageWrapper } from 'components/PasswordResetPage/PasswordResetPage';
import { WebOfferPageWrapper } from 'components/WebOfferPage/WebOfferPage';

export function AppRoutes(): React.JSX.Element {
  return (
    <Switch>
      <Route path="/register/password_reset">
        <PasswordResetPageWrapper variant={PasswordResetPageVariant.REGISTER} />
      </Route>
      <Route path="/auth/password_reset">
        <PasswordResetPageWrapper variant={PasswordResetPageVariant.AUTH} />
      </Route>
      <Route path="/web_offer/:candidateEmail">
        <WebOfferPageWrapper />
      </Route>
      <Route path="/web_offer">
        <WebOfferPageWrapper />
      </Route>
      <Route path="/employee/editor/:pageUuid">
        <CandidatePortalEditor />
      </Route>
      <Route path="/employee">
        <EmployeePage />
      </Route>
      <Route path="/login">
        <LoginPage />
      </Route>
      <Route path="/forbidden">
        <ForbiddenPage />
      </Route>
      <Route path="/not_found">
        <NotFoundPage />
      </Route>
      <Route path="/expired">
        <ExpiredPage />
      </Route>
      <Route path="/error">
        <ErrorPage />
      </Route>
      <Route path="/">
        <Redirect to="/not_found" />
      </Route>
    </Switch>
  );
}
